import { customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

import { BaseErrorView } from '~/components/base-error-view/BaseErrorView';

export const Cards = styled.div`
  max-height: 40vh;
  overflow: scroll;
  ${customScrollMinimal};

  & > div:last-child {
    margin-bottom: 100px;
  }
`;

export const StyledBaseErrorView = styled(BaseErrorView)`
  max-height: 200px;
  border-bottom: 1px solid var(--border-soft);
`;
